import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUploadWithTag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 21,
	viewBox: "0 0 19 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.69045 19.5795H4.72371C3.73819 19.5795 2.79303 19.1879 2.09617 18.4911C1.3993 17.7942 1.00781 16.8491 1.00781 15.8636V12.9745C1.00781 9.79859 2.2694 6.75288 4.51505 4.50724C6.7607 2.26159 9.80643 1 12.9823 1H14.0135C14.9989 1 15.9442 1.39149 16.641 2.08836C17.3378 2.78523 17.7294 3.73037 17.7294 4.71589V9.76942",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.1324C1 8.33889 6.10939 12.2033 9.10994 9.19345C12.1105 6.18363 8.27386 1 13.0581 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.528 16.6942C15.1723 16.6942 15.6947 16.1719 15.6947 15.5275C15.6947 14.8832 15.1723 14.3608 14.528 14.3608C13.8837 14.3608 13.3613 14.8832 13.3613 15.5275C13.3613 16.1719 13.8837 16.6942 14.528 16.6942Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1771 13.3402L17.7859 14.9458C17.8538 15.013 17.9076 15.0929 17.9444 15.181C17.9811 15.2691 18 15.3635 18 15.4589C18 15.5543 17.9811 15.6488 17.9444 15.7368C17.9076 15.8249 17.8538 15.9049 17.7859 15.9721L14.9655 18.7867C14.8985 18.8543 14.8187 18.9079 14.7308 18.9446C14.6428 18.9811 14.5485 19 14.4532 19C14.358 19 14.2636 18.9811 14.1757 18.9446C14.0878 18.9079 14.008 18.8543 13.941 18.7867L12.2814 17.1189C11.9175 16.7634 11.6368 16.3319 11.4595 15.8554C10.2518 12.5665 11.4595 11.2798 14.6733 12.3916C15.2396 12.5912 15.7535 12.9154 16.1771 13.3402Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconUploadWithTag;
